import React from 'react'
import * as common from '../component'
import { useMediaQuery } from 'react-responsive';

const Home = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 991px)' });
  return (
    <>
      { isMobile ? 
      <common.MobileBanner />
      :<common.Banner/>
    }
      <common.ChooseMiracle/>
      <common.Amentinies />
      <common.Location />
      <common.About />
      <common.Facing /> 
      <common.Testimonials/>
      {/* <common.Offer /> */}
      <common.CommonBackground child="ready"/>
      <common.Footer />
    </>
  )
}

export default Home
